import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../../utils/utils";
import NumberFormat from "react-number-format";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { getDeliveriesBySo } from "../../../../../services/sales/salesDeliveryService";
import DeliveryDetail from "../../../inventory/stock-management/delivery/deliveryDetail";
import { DialogActions } from "@material-ui/core";
import DialogLayout from "../../../../../partials/content/DialogLayout";
const itemIssuedDetailColumn = [
  {
    header: "Created At",
    field: "CreatedAt",
    type: "datetime",
  },
  {
    header: "Created By",
    field: "createdByName",
    type: "string",
  },
  {
    header: "Updated At",
    field: "UpdatedAt",
    type: "datetime",
  },
  {
    header: "Updated By",
    field: "updatedByName",
    type: "string",
  },
];
function SoDeliveryOrder({ salesOrderID = 0 }) {
  const [soDeliveries, setSoDeliveries] = useState([]);
  const [deliveryOrderID, setDeliveryOrderID] = useState(0);
  const [openDeliveryDetail, setOpenDeliveryDetail] = useState(false);
  useEffect(() => {
    if (salesOrderID > 0) {
      getDeliveriesBySo(salesOrderID).then((response) => {
        const { data } = response.data;
        setSoDeliveries(data.deliveries);
      });
    }
  }, [salesOrderID]);
  return (
    <React.Fragment>
      {soDeliveries.length ? (
        <React.Fragment>
          <CustomDataTable
            data={soDeliveries}
            dataDetailColumns={itemIssuedDetailColumn}
            onRefreshData={() => {}}
            columns={[
              {
                header: "Delivery ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Delivery Date",
                field: "deliveryDate",
                body: (rowData) => formatDate(rowData.deliveryDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Delivery Cost",
                field: "deliveryCost",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.deliveryCost}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Delivery Order Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setDeliveryOrderID(rowData.ID);
                          setOpenDeliveryDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            guidance={`You don't have any Delivery Order for this sales order yet`}
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
      <DialogLayout
        open={openDeliveryDetail}
        title="Delivery Order Detail"
        onCloseDialog={() => {
          setOpenDeliveryDetail(false);
        }}
        minHeight={true}
      >
        <DeliveryDetail deliveryID={deliveryOrderID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenDeliveryDetail(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SoDeliveryOrder;
